import SignupPageDesigner from '@admin/components/signup_page_designer'
import Panel from '@admin/components/panel'
import PropTypes from 'prop-types'
import React from 'react'

class SignupPage extends React.Component {

  static propTypes = {}

  render() {
    return <SignupPageDesigner { ...this._getSignupPageDesigner() } />
  }

  _getSignupPageDesigner() {
    return {
      endpoint: '/api/admin/team/affiliate/signup_page',
      signup_page_id: 10
    }
  }

}

const mapResourcesToPanel = (props, context) => ({
  affiliate: '/api/admin/team/affiliate/signup_page'
})

const mapPropsToPanel = (props, context) => ({
  title: 't(Signup Page)',
  component: <SignupPage affiliate={ props.affiliate } />
})

export default Panel(mapResourcesToPanel, mapPropsToPanel)
